<template>
  <div class="bulk-order-about">
    <AboutTopSection />
    <AboutOverviewSection />
    <AboutGiftCardSection />
    <AboutSuggestionSection />
    <AboutPopularGiftsSection />
    <AboutUsageFlowSection />
    <AboutAskedQuestionSection />
    <ApplyBulkOrderButton
      class="bulk-order-about__apply-bulk-order-button"
      @click-button="onClickApplyBulkOrderButton"
    />
  </div>
</template>

<script setup>
import AboutTopSection from '../../../organism/bulk_personal_orders/about/AboutTopSection.vue'
import AboutOverviewSection from '../../../organism/bulk_personal_orders/about/AboutOverviewSection.vue'
import AboutGiftCardSection from '../../../organism/bulk_personal_orders/about/AboutGiftCardSection.vue'
import AboutSuggestionSection from '../../../organism/bulk_personal_orders/about/AboutSuggestionSection.vue'
import AboutPopularGiftsSection from '../../../organism/bulk_personal_orders/about/AboutPopularGiftsSection.vue'
import AboutUsageFlowSection from '../../../organism/bulk_personal_orders/about/AboutUsageFlowSection.vue'
import AboutAskedQuestionSection from '../../../organism/bulk_personal_orders/about/AboutAskedQuestionSection.vue'
import ApplyBulkOrderButton from '../../../molecules/buttons/ApplyBulkOrderButton.vue'

function onClickApplyBulkOrderButton() {
  location.href = '/bulk_order/gift_cards'
}
</script>

<style lang="scss" scoped>
.bulk-order-about {
  width: 100%;

  &__apply-bulk-order-button {
    position: fixed;
    right: 3%;
    bottom: 3%;
    z-index: 2; // AboutUsageFlowSectionで使用しているSwiperがz-index:1を使用しており、それより上に表示するため2を指定。
  }
}
</style>
